import { GoalIndexTable } from '@account/services/tables/goal-table/goal-index.table';
import { Component } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { Goal } from '@models/performance/goal.model';
import { PerformanceMenuService } from '@account/services/menus/performance-menu.service';

@Component({
    templateUrl: './goal-index.template.html',
    styleUrls: ['./goal-index.style.scss'],
})
export class GoalIndexView {
    createPermission = Goal.permission.edit;

    constructor(
        public tabMenuService: PerformanceMenuService,
        public table: GoalIndexTable,
        protected auth: AuthService
    ) {
        this.table.reload();
    }
}
